import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthService } from '../auth.service';
import { FuncsService } from 'src/app/shared/funcs.service';
import { AppPaths } from 'src/enums/app-paths';
import { LogService } from 'src/app/shared/log.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { ErrorService } from 'src/app/shared/errors.service';
import {finalize, tap} from 'rxjs/operators';

@Component({
  selector: 'app-password-lost',
  templateUrl: './password-lost.component.html',
  styleUrls: ['./password-lost.component.sass']
})
export class PasswordLostComponent implements OnInit {

  isSpinning = false;
  passwordLostForm!: UntypedFormGroup;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.passwordLostForm = this.fb.group({
      userName: [null, [Validators.required]],
      code: [null, [Validators.required]],
    });
  }

  submitForm(): void {
    for (const i in this.passwordLostForm.controls) {
      this.passwordLostForm.controls[i].markAsDirty();
      this.passwordLostForm.controls[i].updateValueAndValidity();
    }

    const username: string = this.passwordLostForm.value.userName;
    const code: string = this.passwordLostForm.value.code;

    if (!username || !code) {
      return;
    }

    this.isSpinning = true;

    this.authService.recoverLostPassword(username, code).pipe(
      finalize(() => this.isSpinning = false)
    ).subscribe();
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  getAuthLink() {
    return [`/${AppPaths.Auth}`];
  }

  getCodeLostLink() {
    return [`/${AppPaths.Auth}`, AppPaths.CodeLost];
  }

}
